/* eslint-disable @typescript-eslint/prefer-literal-enum-member */

export enum EditMode {
  NONE = 0,

  ADD = 1 << 0,

  CHANGE = 1 << 1,

  REMOVE_DIRECTLY = 1 << 2,
  REMOVE_FROM_LIST = 1 << 3,
  REMOVE = REMOVE_DIRECTLY | REMOVE_FROM_LIST,

  ANY = ADD | REMOVE | CHANGE,
}
